import { api, clearToken, setToken, type StudioUser } from "../api/client";

export async function consumeBridgeToken(token: string) {
  const data = await api<{ token: string; user: StudioUser }>("auth/bridge", {
    method: "POST",
    body: JSON.stringify({ token }),
  });
  setToken(data.token);
  return data.user;
}

export async function loadMe() {
  const data = await api<{ user: StudioUser }>("me");
  return data.user;
}

export async function logout() {
  try {
    await api("auth/logout", { method: "POST" });
  } finally {
    clearToken();
  }
}
